export const SELECT_AND_REMOVE_TEST_ID = 'SelectAndRemove';
export const SELECT_AND_REMOVE_BUTTON_TEST_ID = 'SelectAndRemoveButton';
export const REMOVE_BUTTON_TEST_ID = 'RemoveButton';
export const REMOVE_CANCEL_BUTTON_TEST_ID = 'RemoveCancelButton';

// Modal
export const SELECT_AND_REMOVE_MODAL_CONTENT_TEST_ID = 'SelectAndRemoveModalContent';
export const SELECT_REMOVE_CANCEL_BUTTON_TEST_ID = 'SelectRemoveCancelButton';
export const SELECT_REMOVE_SUBMIT_BUTTON_TEST_ID = 'SelectRemoveSubmitButton';
